import React, { Component } from 'react';
import { Row, Col, Spin, Radio, Button, Input, Select } from 'antd';
import Form from "../../components/Form";
import Card from "../../components/Card";
import { app } from "../../app";
import api from "../../api";

const RadioGroup = Radio.Group;
const RadioButton = Radio.Button;
const Option = Select.Option;

class Organization extends Component {
    constructor (props) {
        super(props);
        this.state = {
            edit_index: undefined,
            add_state: true,
            loading: true,
            ppeTypes: [],
            dataList: [],
        };
    }

    /**
     * 技能类别列表
     **/
    ppeTypeData = async () => {
        let { flag, data, msg } = await app.post(api.HomeClassList);
        if (flag === 1) {
            await this.setData({ ppeTypes: data });
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * 设置值
     * @param data
     */
    setData = async (data) => {
        await app.setStateSync(this, data);
    }

    /**
     * 列表
     **/
    dataSource = async () => {
        let params = {
            indexno: app.getData("indexno"),
            account: app.getData("account"),
        };
        let { flag, data, msg } = await app.post(api.OAgencyList, params);
        let state = { loading: false };
        if (flag === 1) {
            state.dataList = data;
        } else {
            app.alert(msg, "error");
        }
        await this.setData(state);
    }

    componentDidMount () {
        this._isMounted = true;
        this.ppeTypeData();
        this.dataSource();
    }

    componentWillUnmount () {
        this._isMounted = false;
    }

    /**
     * 选择机构
     * @param e
     * @returns {Promise<void>}
     */
    handleSelectOrganization = async (e) => {
        let edit_index = e.target.value;
        await this.setData({ edit_index, add_state: false });
        let {dataList} = this.state;
        if (this.editForm) {
            let {organization_name, ppe_class_id, id} = dataList[edit_index];
            this.editForm.setFieldsValue({
                id,
                name: organization_name,
                class_id: ppe_class_id ? ppe_class_id.split(',') : [],
            });
        }

    }

    /**
     * 提交
     * @param value
     * @returns {Promise<void>}
     */
    handleSubmit = async (value) => {
        await this.setData({submit_loading: true});
        let {add_state} = this.state;
        value.indexno = app.getData("indexno");
        value.account = app.getData("account");
        value.class_id = value.class_id.join(",");
        value.type = add_state ? 1 : 2;
        let { flag, msg } = await app.post(api.OAgencyEdit, value);
        await this.setData({ submit_loading: false });
        if (flag === 1) {
            app.alert("提交成功", "success");
            await this.dataSource();
        } else {
            app.alert(msg, "error");
        }
    }

    /**
     * form对象
     * @param editForm
     */
    handleFormRef = (editForm) => {
        this.editForm = editForm;
    }

    /**
     * 设置添加
     * @returns {Promise<void>}
     */
    handleSetAdd = async () => {
        await this.setData({add_state: true, edit_index: undefined})
        if (this.editForm) {
            this.editForm.setFieldsValue({
                id: '',
                name: '',
                class_id: undefined,
            });
        }
    }

    render () {
        let { loading, edit_index, dataList, ppeTypes, add_state, submit_loading } = this.state,
            formItemLayout = {
                labelCol: { span: 6 },
                wrapperCol: { span: 12, offset: 1 },
            },
            card_style = {
                padding: 25,
                height: 'calc(100% - 68px)',
                borderLeft: '1px solid #eee',
                borderBottom: '1px solid #eee',
                borderRight: '1px solid #eee'
            };
        let edidNodes = [
                {
                    name: "id",
                    component: (
                        <Input type="hidden"/>
                    ),
                },
                {
                    label: "机构名称",
                    name: "name",
                    options: {
                        rules: [{ required: true, message: '请填写机构名称！' }]
                    },
                    component: (
                        <Input placeholder="请填写机构名称"/>
                    ),
                },
                {
                    label: "技能类别",
                    name: "class_id",
                    options: {
                        rules: [{ required: true, message: '请选择技能类别！' }]
                    },
                    component: (
                        <Select placeholder="请选择技能类别" optionFilterProp="children" notFoundContent="无" mode="multiple" showSearch>
                            {
                                ppeTypes.map((t, i) => {
                                    return (
                                        <Option key={i} value={t.id}>{t.names}</Option>
                                    );
                                })
                            }
                        </Select>
                    ),
                }
            ];
        return (
            <Row className="organization">
                <Col span={6} style={{ height: '100%' }}>
                    <Card className="organization-list" width="100%" height="100%" style={card_style} title={<div style={{height: 32}}>已添加的认证机构</div>}>
                        {
                            loading ?
                                (
                                    <Row className="data-loading" type="flex" align="middle" justify="center">
                                        <Spin size="small"/>
                                    </Row>
                                ) :
                                (
                                    <RadioGroup onChange={this.handleSelectOrganization} className="items"
                                                value={edit_index}>
                                        {
                                            dataList.map((item, index) => {
                                                return (
                                                    <RadioButton key={index} className='no-select' value={index}>
                                                        <div
                                                            title={item.organization_name}>{item.organization_name}</div>
                                                    </RadioButton>
                                                )
                                            })
                                        }
                                    </RadioGroup>
                                )
                        }
                    </Card>
                </Col>
                <Col span={17} offset={1} style={{ height: '100%' }}>
                    <Card className="organization-list" width="100%" height="100%" style={card_style} title={
                        <div>
                            <div style={{float: "left"}}>{add_state ? "添加" : "编辑"}认证机构</div>
                            <Button style={{float: "right"}} type="primary" onClick={() => this.handleSetAdd()}>添加新的认证机构</Button>
                        </div>
                    }>
                        <Form formItemLayout={formItemLayout} onSubmit={this.handleSubmit} onRef={this.handleFormRef}
                              button={<div style={{ textAlign: "center" }}>
                                  <Button type="primary" htmlType="submit" loading={submit_loading}>提交</Button></div>}
                              children={edidNodes}/>
                    </Card>
                </Col>
            </Row>
        );
    }
}

export default Organization;



// WEBPACK FOOTER //
// ./src/routes/grade/Organization.jsx